import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { LeadViewDetailComponent } from './lead-view-detail/lead-view-detail.component';
import { EditLeadComponent } from './edit-lead/edit-lead.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import * as XLSX from 'xlsx';


export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  serialNumber?: number;
  agentName?: string;
  email?: string;
  phoneNumber?: string;
  agentType?: string;
  assignedLeads?: string;
  status?: string;
  action?: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];

@Component({
  selector: 'app-leads-list',
  imports: [MaterialModule, CommonModule],
  templateUrl: './leads-list.component.html',
  styleUrl: './leads-list.component.scss'
})
export class LeadsListComponent {
  displayedColumns: string[] = ['leadsId', 'notes', 'email', 'phoneNumber', 'budget', 'commission', 'assignedAgents', 'status', 'action'];
  dataSource = ELEMENT_DATA;

  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    console.log(this.dataSource)
  }

  onFileSelected(event: any) {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      // Validate file type based on extension
      const validExtensions = ['.csv', '.xls', '.xlsx'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase(); // Get the file extension




      if (!validExtensions.includes(fileExtension)) {
        alert('Please select a CSV or Excel file.');
        return;
      }
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const binaryString = e.target.result;
        const workbook = XLSX.read(binaryString, { type: 'binary' });

        // Process the first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        console.log('josn sas',jsonData); // Process the Excel data
      };

      // Continue with file processing
      console.log('File selected:', file);
      // You can now read the file or upload it to a server
    }
  }

  leadViewDetail(element: any) {
    const dialogRef = this.dialog.open(LeadViewDetailComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  edit(data: any) {
    const dialogRef = this.dialog.open(EditLeadComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      // panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  deleteItem(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      panelClass: 'confirm-dialog',
      position: {
        top: '10px', // Align to the top
        // left: '40%', // Center horizontally
      },
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          yes: 'yes',
          no: 'no'
        }
      },
    }).afterClosed().subscribe((result: any) => {
      console.log('Dialog closed with result:', result);
      if (result === true) {
        // Perform delete operation or further logic
      }
    });
  }

  onActionSelect(event: any) { }

  onAction1(element: any) { }
}
